import { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import AnaSayfa from './components/Pages/AnaSayfa';
import KonferansEkibi from './components/Pages/KonferansEkibi';
import Hakkimizda from './components/Pages/Hakkimizda';
import KayitOl from './components/Pages/KayitOl';
import Paketler from './components/Pages/Paketler';
import Iletisim from './components/Pages/Iletisim';
import Ulasim from './components/Pages/Ulasim';
import Formlar from './components/Pages/Formlar';
import Program from './components/Pages/Program';
import Admin from './components/Pages/Admin';
import AdminLogin from './components/Pages/AdminLogin';
import Tesekkurler from './components/Pages/Tesekkurler';
import TesekkurlerCC from './components/Pages/TesekkurlerCC';
import EkPaketler from './components/Pages/EkPaketler';
import OdemeBasarili from './components/Pages/OdemeBasarili';
import OdemeHata from './components/Pages/OdemeHata';
import OdemeBekleme from './components/Pages/OdemeBekleme';

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Routes>
      <Route path="/admin" element={<Admin />} />
      <Route path="/admin/giris" element={<AdminLogin />} />
      <Route path="/" element={<Layout />}>
        <Route index element={<AnaSayfa />} />
        <Route path="konferans-ekibi" element={<KonferansEkibi />} />
        <Route path="hakkimizda" element={<Hakkimizda />} />
        <Route path="kayit-ol" element={<KayitOl />} />
        <Route path="paketler" element={<Paketler />} />
        <Route path="iletisim" element={<Iletisim />} />
        <Route path="ulasim" element={<Ulasim />} />
        <Route path="formlar" element={<Formlar />} />
        <Route path="program" element={<Program />} />
        <Route path="ek-paketler" element={<EkPaketler />} />
        <Route path="tesekkurler" element={<Tesekkurler />} />
        <Route path="tesekkurler-cc" element={<TesekkurlerCC />} />
        <Route path="payment/success" element={<OdemeBasarili />} />
        <Route path="payment/failure" element={<OdemeHata />} />
        <Route path="payment/pending" element={<OdemeBekleme />} />
      </Route>
    </Routes>
  );
}

export default App;
